<template>
<div class="transfer-view">
        <div class="transfer-view-content">
            <div class="top">
                <div class="title">{{$t("转移所有权")}}</div>
                <div class="close-btn" @click.stop="handleClose">
                    <svg-icon name="header-file_transfer_close" class="close-icon"></svg-icon>
                </div>
            </div>
            <div class="center" :style="'padding-bottom: 24px'">
                <div class="title">{{$t("转移给：")}}</div>
                <div class="member-input" ref="inputContainer" @mouseenter="hoverInput(true)" @mouseleave="hoverInput(false)">
                    <MemberTag v-if="selectedMember" :data="selectedMember" @deleteMember="deleteMember"></MemberTag>
                    <a-trigger position="bl" trigger="focus" v-model="this.searchText" :click-outside-to-close="false" :blur-to-close="false">
                        <div ref="searchInput" class="search-input" contenteditable="true" @input="searchMembers" @focus="searchInputFocus" @blur="handleBlur" @keydown="handleKeyDown">
                            <div id="search-placeholder">{{$t("输入用户姓名查找")}}</div>
                        </div>
                        <template #content>
                            <SearchMember v-show="!selectedMember" :searchText="searchText" @selectMember="selectMember"></SearchMember>
                        </template>
                    </a-trigger>
                    <div v-show="searchText" class="clear-btn" @click.stop="clearText">
                        <svg-icon name="header-file_transfer_input_clear" class="clear-icon"></svg-icon>
                    </div>
                </div>
                <div class="options" v-if="transferType === 'file'">
                    <a-checkbox class="file-transfer-options-checkbox" v-model="transferChild"></a-checkbox>
                    <span>{{$t("同时转移该文件夹下属于我的子文件夹、文档")}}</span>
                </div>
            </div>
            <div class="bottom">
                <div class="btn cancel" @click.stop="handleClose">{{$t("取消")}}</div>
                <div class="btn confirm" :class="{ disabled: !selectedMember }" @click.stop="handleTransfer">{{$t("转移")}}                </div>
            </div>

            <a-modal class="file-share-common-dialog" v-model:visible="confirmDialogVisible" :simple="true" :footer="false" :render-to-body="false">
                <div class="content">
                    <div class="title">
                        <img src="@/assets/img/share/icon_file_tip.png"/>{{$t("提示")}}                    </div>
                    <div class="desc">
                        {{ confirmDesc }}
                    </div>
                    <div class="bottom">
                        <div class="cancel-btn" @click.stop="confirmDialogVisible = false">{{$t("取消")}}                        </div>
                        <div class="confirm-btn" @click.stop="confirmToTransfer">{{$t("确认")}}                        </div>
                    </div>
                </div>
            </a-modal>
        </div>
    </div>
</template>

<script lang="ts">
import { intl } from 'tci18n-vue3'
import SearchMember from './SearchMember.vue';
import MemberTag from './MemberTag.vue';
import { transferFileOwner } from '../../core/api/file';
import { getBrowser } from '@/utils/browser';

export default {
  name: 'TransferView',
  components: {
    SearchMember,
    MemberTag },

  props: {
    fileId: {
      type: String },

    transferType: {
      type: String,
      default: 'file' // file | wiki
    } },

  emits: ['closeTransferDialog', 'transferWikiOwner'],
  data() {
    return {
      transferChild: false,
      confirmDialogVisible: false,
      searchText: '',
      isFocus: false,
      selectedMember: null };

  },
  computed: {
    confirmDesc() {
      if (this.transferType === 'file') {
        return intl.$t(`转移后你将不再是此文档的所有者，是否将所有权转移给{slot0}`, { slot0: this.selectedMember?.memberName });
      } else {
        return intl.$t(`转移后你将不再是此知识库的所有者，是否将所有权转移给 {slot0} ？`, { slot0: this.selectedMember?.memberName });
      }
    } },

  watch: {},
  methods: {
    handleClose() {
      this.$emit('closeTransferDialog');
    },
    handleTransfer() {
      if (!this.selectedMember) {
        return;
      }
      this.confirmDialogVisible = true;
    },
    confirmToTransfer() {
      if (this.transferType === 'file') {
        const data = {
          spaceId: this.selectedMember.spaceId,
          userId: this.selectedMember.userId,
          transferChild: this.transferChild };

        transferFileOwner(this.fileId, data).
        then((response: any) => {
          const res = response.data;
          if (res.code === 200) {
            this.confirmDialogVisible = false;
            this.handleClose();
            if (!res.data?.transferChild) {
              this.$message.success(intl.$t("转移所有权成功"));
              // 更新编辑器中的文档创建人信息
              // window['tocaEditor']?.getDocInfoFromServer(this.fileId);
              // 434 - 转移所有权限后，重刷页面
              setTimeout(() => {
                if (getBrowser().isInTocaApp === true) {
                  window.open(window.location.href, '_self');
                } else {
                  window.location.reload();
                }
              }, 400);
            }
          } else {
            this.$message.error(intl.$t(`转移所有权失败`));
          }
        }).
        catch((err) => {
          this.$message.error(intl.$t("转移所有权失败，请重新尝试"));
        });
      } else {
        this.$emit('transferWikiOwner', this.selectedMember.id);
      }
    },
    searchMembers(event) {
      this.searchText = event.target.innerText;
      this.handleRemovePlaceholder();
    },
    searchInputFocus() {
      this.handleRemovePlaceholder();
      this.isFocus = true;
      this.inputContainerBorderStyle(true);
      this.handleRange();
    },
    handleRange() {
      const input = this.$refs.searchInput;
      const range = document.createRange();
      const sel = window.getSelection();
      range.setStart(input, 0);
      range.collapse(true);
      sel?.removeAllRanges();
      sel?.addRange(range);
      setTimeout(() => {
        this.$refs.searchInput.focus();
      }, 300);
    },
    handleBlur() {
      this.isFocus = false;
      if (this.searchText) {
        this.$refs.inputContainer.style.background = '#FFFFFF';
      } else {
        this.handleAddPlaceholder();
        this.inputContainerBorderStyle(false);
      }
    },
    handleKeyDown(event) {
      if (event.key === 'Enter') {
        event.preventDefault();
      }
    },
    clearText() {
      this.$refs.searchInput.innerText = this.searchText = '';
      this.$refs.searchInput.focus();
    },
    hoverInput(isHover: boolean) {
      if (this.selectedMember) {
        return;
      }
      if (isHover) {
        this.inputContainerBorderStyle(true);
      } else {
        if (!this.isFocus) {
          this.inputContainerBorderStyle(false);
        }
      }
    },
    inputContainerBorderStyle(hasBorder: boolean) {
      if (hasBorder) {
        this.$refs.inputContainer.style.border = '1px solid #5C70FF';
        this.$refs.inputContainer.style.background = '#FFFFFF';
      } else {
        this.$refs.inputContainer.style.border = '1px solid #F5F6F7';
        this.$refs.inputContainer.style.background = '#F5F6F7';
      }
    },
    handleAddPlaceholder() {
      const placeholder = document.createElement('div');
      placeholder.id = 'search-placeholder';
      placeholder.innerText = intl.$t("输入用户姓名查找");
      this.$refs.searchInput.appendChild(placeholder);
    },
    handleRemovePlaceholder() {
      let t = this.$refs.searchInput.querySelector('#search-placeholder');
      if (!!t) {
        t.remove();
      }
    },
    selectMember(item: any) {
      this.$refs.searchInput.innerText = this.searchText = '';
      this.selectedMember = item;
      this.inputContainerBorderStyle(false);
    },
    deleteMember(item: any) {
      this.selectedMember = null;
      this.$nextTick(() => {
        this.$refs.searchInput.focus();
      });
    } },

  created() {},
  mounted() {},
  beforeUnmount() {},
  destroyed() {} };
</script>

<style lang="scss">
.transfer-view {
    width: 100%;
    position: relative;

    .transfer-view-content {
        height: 100%;
        padding: 24px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;

        .top {
            width: 100%;
            display: flex;
            justify-content: space-between;

            .title {
                font-weight: 600;
                font-size: 16px;
                color: #000000d9;
                line-height: 24px;
            }

            .close-btn {
                width: 24px;
                height: 24px;
                cursor: pointer;

                .close-icon {
                    padding: 6px;
                    width: 12px;
                    height: 12px;
                }

                &:hover {
                    background: #f4f6f9;
                    border-radius: 4px;
                }
            }
        }

        .center {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            width: 100%;
            padding: 24px 0 40px 0;

            .title {
                font-family: PingFangSC-Regular;
                font-weight: 400;
                font-size: 14px;
                color: #121317d9;
                line-height: 24px;
                margin-bottom: 8px;
            }

            .member-input {
                width: 100%;
                height: 32px;
                background: #f5f6f7;
                border-radius: 6px;
                border: 1px solid #f5f6f7;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                position: relative;

                .search-input {
                    display: inline-flex;
                    flex: 1;
                    padding: 6px 12px;
                    background: transparent;
                    border: none;
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    font-size: 14px;
                    line-height: 20px;
                    color: #121317;
                    text-align: left;

                    &:focus-visible {
                        outline: none;
                    }
                }

                .search-input-placeholder {
                    display: inline-block;
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    font-size: 14px;
                    color: #a2a4b0;
                    line-height: 20px;
                    cursor: text;
                }

                .clear-btn {
                    width: 16px;
                    height: 16px;
                    padding-right: 12px;
                    display: flex;
                    cursor: pointer;

                    .clear-icon {
                        width: 16px;
                        height: 16px;
                    }
                }
            }

            .options {
                margin-top: 8px;
                display: flex;
                align-items: center;

                span {
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    font-size: 14px;
                    color: #646a73;
                    line-height: 20px;
                }
            }
        }

        .bottom {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            width: 100%;

            .btn {
                width: 88px;
                height: 36px;
                border-radius: 6px;
                font-family: PingFangSC-Medium;
                font-weight: 500;
                font-size: 14px;
                text-align: center;
                line-height: 36px;
                margin-left: 16px;
                cursor: pointer;

                &.cancel {
                    color: #222329;
                    background: #ffffff;
                    border: 1px solid #e8e9ee;

                    &:hover {
                        background: #f4f6f9;
                    }
                }

                &.confirm {
                    color: #ffffff;
                    background: #5c70ff;

                    &:hover {
                        background: #6d7dff;
                    }

                    &.disabled {
                        background: #ced4ff;
                        border-radius: 6px;
                        cursor: not-allowed;
                    }
                }
            }
        }
    }

    #search-placeholder {
        display: inline-block;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #a2a4b0;
        line-height: 20px;
        cursor: text;
    }
}
</style>

<style lang="scss">
@import '../share/theme/commonDialog.scss';

.file-transfer-options-checkbox {
    width: 16px;
    height: 16px;
    padding-left: 0;
    margin-right: 8px;

    .arco-checkbox-icon {
        width: 16px;
        height: 16px;
        border-radius: 4px;
        border: 1px solid #e8e9ee;

        &:hover {
            border: 1px solid #5c70ff;
        }
    }

    .arco-icon-hover-disabled {
        .arco-checkbox-icon {
            width: 16px;
            height: 16px;
            border-radius: 4px;
            border: 1px solid #5c70ff;
        }
    }

    .arco-icon-hover {
        &:hover::before {
            background-color: transparent !important;
        }
    }
}
</style>
